import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

/**
 * React Error Boundary - faengt Render-Fehler in der Komponenten-Hierarchie ab.
 * Zeigt den nativen error-fallback aus index.html an, anstatt die App abstuerzen zu lassen.
 */
export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('[ErrorBoundary] React Render-Fehler:', error, errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // Nativen error-fallback aus index.html anzeigen
      const fallback = document.getElementById('error-fallback');
      const root = document.getElementById('root');
      if (fallback && root) {
        fallback.style.display = 'flex';
        root.style.display = 'none';
      }
      return null;
    }

    return this.props.children;
  }
}
